import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { IconButton, Switch, Tooltip } from '@mui/material';
import { Brush, ViewQuiltRounded } from '@mui/icons-material';
import { useAnchor, useCallbacks } from 'shared/hooks/utils';
import { set_ui_settings } from 'console/redux/settings-actions';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { UniversalMenu } from 'console/shared/components/menu';
import { ChangeVehicleModelDialog } from './change-model';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { useAction } from 'shared/hooks/redux/hooks';
export const VehicleUIControl = memo(function ChangeModelView() {
    const [dialog_opened, closeDialog, openDialog] = useBooleanState(false);
    const [anchor, openMenu, closeMenu] = useAnchor();
    const { sorting_mode } = useContext(DeviceUISettingsContent);
    const { device_id } = useContext(DeviceConfig);
    const onChangeModelClick = useCallbacks([openDialog, closeMenu]);
    const setUISettings = useAction(set_ui_settings);
    const onSortingModeClick = useCallback(() => {
        setUISettings({
            sorting_mode: sorting_mode ? false : device_id,
        });
    }, [setUISettings, sorting_mode, device_id]);
    const menu_items = useMemo(() => [
        {
            label: 'Режим конструктора',
            icon: (_jsx(ViewQuiltRounded, { fontSize: "small", color: sorting_mode ? 'primary' : 'action' })),
            onClick: onSortingModeClick,
            additional_view: _jsx(Switch, { size: "small", checked: sorting_mode }),
        },
        {
            icon: _jsx(Brush, { color: "action" }),
            label: 'Настройка вида',
            onClick: onChangeModelClick,
        },
    ], [sorting_mode]);
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0438\u0434\u0430", children: _jsx(IconButton, { onClick: openMenu, size: "large", sx: { px: 0 }, color: "neutral", children: sorting_mode ? (_jsx(ViewQuiltRounded, { fontSize: "small", color: "primary" })) : (_jsx(Brush, { fontSize: "small" })) }) }), _jsx(ChangeVehicleModelDialog, { opened: dialog_opened, onClose: closeDialog }), _jsx(UniversalMenu, { opened: !!anchor, anchor: anchor, onClose: closeMenu, menu_items: menu_items })] }));
});
